import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

import {createElement, PropTypes} from 'rlink-react';
import LegacyScrollTransition from 'rlink-transitions/LegacyScrollTransition';

export default function EliteDescriptionPanelEldar ({css}) {
  return (
    <LegacyScrollTransition css={css}>
      <div className={css.column}>
        <h1>
          <FormattedHTMLMessage
            id="ui.branding.heading.DOW3_FARSEER_MACHA_DESCIPTION_PANEL_ANIMATED_TAGLINE"
            defaultMessage={'<span class="{FIRST_CLASSNAME}">Farseer</span> <span class="{SECOND_CLASSNAME}">Macha</span>'}
            description="Animated tagline appearing on the Eldar faction page. The two different <span>...</span> parts fade-in one after the other and should be of roughly equal size. {FIRST_CLASSNAME} and {SECOND_CLASSNAME} are used to give the different parts their animations and should remain in order."
            values={{
              FIRST_CLASSNAME: css.first,
              SECOND_CLASSNAME: css.second,
            }} />
        </h1>
        <hr style={{marginLeft: 0}} className={css.short} />
        <p>
          <FormattedMessage
            id="ui.branding.copy.DOW3_FARSEER_MACHA_DESCIPTION_PANEL_BODY"
            defaultMessage="Macha is an Eldar Farseer, a powerful psyker able to read the future. A veteran of countless battles, she serves on the Biel-Tan Craftworld, striving to find a way to avert the extinction of her people. Macha is distrustful of promises of a brighter future, however, and fears her people are being led astray."
            description="Paragraph description of the Eldar hero. Macha is a character. Eldar is a faction name. Biel-Tan is a ship. Farseer, psyker and Craftworld have special meaning in the game universe." />
        </p>
      </div>
    </LegacyScrollTransition>
  );
}

EliteDescriptionPanelEldar.propTypes = {
  css: PropTypes.object,
};



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/components/EliteDescriptionPanelEldar.jsx